<template>
    <div class="b1t-okraina-catalog">
        <b1t-okraina-catalog-sections v-bind:drop_page_loading="true"/>
    </div>
</template>

<script>

    import b1tOkrainaCatalogSections from '../catalog/sections'

    export default {
        name: 'b1t-okraina-main', 
        components: {
            b1tOkrainaCatalogSections
        }

    }
</script>

<style>

</style>